import { abbreviateNumber } from '@fabric-ui/utils';

export const TOOLTIP_SECONDARY_VALUE_MIN_WIDTH = 38;

export const formatTooltipNumberValue = (value: unknown): string | number | undefined => {
  if (value === null || value === undefined || value === '') {
    return value as undefined;
  }

  if (typeof value === 'number') {
    return String(abbreviateNumber(value));
  }

  if (typeof value === 'string') {
    const normalizedValue = value.replace(/,/g, '').trim();
    if (/^-?\d+(\.\d+)?$/.test(normalizedValue)) {
      return String(abbreviateNumber(Number(normalizedValue)));
    }
  }

  return value as string | number;
};

export const getStacked100AbsoluteValue = (
  row: Record<string, any> | undefined,
  dataKey: string | number | undefined
): string | number | undefined => (dataKey ? formatTooltipNumberValue(row?.[dataKey as string]) : undefined);

export const formatStacked100Percentage = (rawValue: unknown): string | undefined => {
  if (rawValue == null) return undefined;
  const num = Number(rawValue);
  return Number.isNaN(num) ? undefined : `${num.toFixed(2)}%`;
};
